import styled from 'vue-styled-components';
import { COLORS } from '../../../colors';
import { FONTS } from '../../../constants';

export const AxesWrapper = styled.g`
  .tick line {
    stroke: ${COLORS.DUSTY_GRAY};
  }

  .tick text {
    fill: ${COLORS.GRAY};
    font-size: 16px;
    font-weight: normal;
    font-family: ${FONTS.KNOCKOUT_50_FONT};
  }

  .domain {
    stroke: ${COLORS.DUSTY_GRAY};
  }

  .left-axis .domain,
  .left-axis line {
    stroke: transparent;
  }
`;

export const GridWrapper = styled.g`
  .tick line {
    stroke: ${COLORS.SILVER};
    stroke-dasharray: 2, 10;
    stroke-width: 2;
  }

  .domain {
    stroke: transparent;
  }
`;
